import { Button } from '@mui/material';

import './styles.scss';

type dataArrType = {
  value: string;
  label: string;
  isVisible: boolean;
};

type ReportFilterButtonsType = {
  titleFilter: string;
  dataArr: dataArrType[];
  selected: string;
  setSelected: (value: string) => void;
  disabled?: boolean;
  disableBorder?: boolean;
  classNames?: string;
};

export const ReportFilterButtons = ({
  titleFilter,
  dataArr,
  selected,
  setSelected,
  disabled = false,
  disableBorder = false,
  classNames = '',
}: ReportFilterButtonsType) => {
  const classNamesContainer = `report-buttons-options ${classNames ? classNames : ''} ${disableBorder ? 'no-border' : ''}`;

  return (
    <div className={classNamesContainer}>
      {titleFilter.length > 0 && <span className="report-buttons-label">{titleFilter}</span>}
      {dataArr?.map((item) => {
        if (!item.isVisible) return;

        return (
          <div key={item.value} className="report-buttons-options-list">
            <Button
              key={item.value}
              className={`range-btn ${item.value === selected ? 'selected-range' : 'not-selected-range'}`}
              onClick={() => !disabled && setSelected(item.value)}
              disabled={disabled}
            >
              {item.label}
            </Button>
          </div>
        );
      })}
    </div>
  );
};
